const axios = require('axios');

async function getSkins(condition) {
  try {
    const resData = await axios.get('/api/v1/admin/skin/all', { params: condition });
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function findSkinById(id) {
  try {
    const resData = await axios.get('/api/v1/admin/skin', { params: { id } });
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function updateSkin(params) {
  try {
    const resData = await axios.put('/api/v1/admin/skin', params);
    return resData;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function uploadSkinImage(id, imageFile) {
  try {
    const data = new FormData();
    data.append('_id', id);
    data.append('image', imageFile);
    const resData = await axios.put('/api/v1/admin/skin/image', data);
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

module.exports = { getSkins, findSkinById, updateSkin, uploadSkinImage };
